/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './schema.defs'
export { main as default } from './schema.defs'
